import React from 'react';

import EditProfile from './EditProfile';
import AdminLayout from '../../../components/Layout/AdminLayout';

import NotFound from '../../notFound/NotFound';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.editProfile);
    let isAdminAuthenticated, profile;

    isAdminAuthenticated = store.getState()?.runtime?.isAdminAuthenticated;

    const profileId = params.profileId;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    profile = Number(profileId);

    return {
        title,
        component: <AdminLayout><EditProfile profileId={profile} /></AdminLayout>
    };
}
